<template>
    <div class="login-body">
        <div class="login-panel p-fluid">
            <div class="login-panel-content">
                <div class="grid">
                    <div class="p-mb-5">
                        <div class="p-d-flex p-jc-center p-mb-5"><img style="max-width: 20%" src="/assets/logo-highlight-common.svg" alt="yuzaner" /></div>

                        <h3 class="p-d-flex p-jc-center p-mt-2"><span>{{ $store.state.i18n.messageBundle?.password_reset?.title }}</span></h3>

                        <form @submit.prevent="onSubmit" class="p-my-5">
                            <div v-if="isRequestSuccess" class="p-fluid">
                                <div class="p-my-3">
                                    <InlineMessage severity="info">
                                        Password reset code SMS was sent do your registerred phone. Please check your SMS message and proceed to reset your password.
                                    </InlineMessage>
                                    <Button class="p-button-primary" @click="gotoPasswordResetWithPhone()" :label="'Reset Password with Phone'"></Button>
                                </div>
                            </div>
                            <div v-else class="p-fluid">

                                

                                <div class="p-my-3">                                    
                                    <div class="p-mb-2">
                                        <label for="phone" class="account-attr-font"><strong>{{ $store.state.i18n.messageBundle?.profile?.phone }}</strong></label>
                                    </div>
                                    <Dropdown
                                        v-model="countryPhoneValue"
                                        :options="countryPhoneValues"
                                        optionLabel="name"
                                        :placeholder="$store.state.i18n.messageBundle?.contact_info?.place_holder?.country_code+' *'"
                                        :filter="true"
                                        :showClear="true"
                                        @change="updateCountryCode()"
                                        class="multiselect-custom p-mr-3"
                                    >
                                        <template #value="slotProps">
                                            <div class="country-item country-item-value" v-if="slotProps.value">
                                                <img alt="flg" src="assets/demo/flags/flag_placeholder.png" :class="'flag flag-' + slotProps.value.code.toLowerCase()" />
                                                <div>{{ slotProps.value.name }}</div>
                                            </div>
                                            <template v-else>
                                                {{ slotProps.placeholder }}
                                            </template>
                                        </template>
                                        <template #option="slotProps">
                                            <div class="country-item">
                                                <img alt="flg" src="assets/demo/flags/flag_placeholder.png" :class="'flag flag-' + slotProps.option.code.toLowerCase()" />
                                                <div>{{ slotProps.option.name }}</div>
                                            </div>
                                        </template>
                                    </Dropdown>
                                    <div class="phone-number-holder">
                                        <InputText style="text-align: right; max-width: 100px;" 
                                        :placeholder="$store.state.i18n.messageBundle?.contact_info?.country_code" v-model="phoneCountryCode" disabled class="p-mt-3 country-code" :class="{ 'p-invalid': v$.phone.$invalid && submitted }" />
                                        <InputText
                                            id="phone"
                                            :placeholder="$store.state.i18n.messageBundle?.contact_info?.place_holder?.phone_number+' *'"
                                            v-model="v$.phone.$model"
                                            :disabled="!phoneCountryCode || phoneCountryCode.length < 1"
                                            type="number"
                                            class="p-mt-3 phone-number-input"
                                            :class="{ 'p-invalid': v$.phone.$invalid && submitted }"
                                        />
                                    </div>
                                    <div>
                                        <small v-if="v$.phone.$invalid && submitted" class="p-error p-mt-3">
                                            {{ $store.state.i18n.messageBundle?.profile?.phone }}&nbsp;{{ $store.state.i18n.messageBundle?.common?.required_field }}
                                        </small>
                                    </div>
                                </div>

                                <div class="p-my-1">
                                    <Button :disabled="isProcessing || v$.phone.$invalid || submitted" class="p-button-primary" 
                                    @click="sendResetPasswordRequest()" :label="$store.state.i18n.messageBundle?.password_reset?.sms_reset_code_req"></Button>
                                </div>


                                <div class="p-my-3">
                                    <InlineMessage v-if="isError" severity="error">Cannot find registered phone! Ensure you enter your registered phone number correctly.</InlineMessage>
                                </div>

                            </div>
                        </form>
                        <hr />
                        <div class="p-mt-3">
                            <h5>{{ $store.state.i18n.messageBundle?.common?.useful_links }}</h5>
                            <div class="p-mb-3">
                                <a class="p-button-link" @click="gotoPasswordResetWithPhone()">&nbsp;<span class="pi pi-check-circle"></span>&nbsp;{{ $store.state.i18n.messageBundle?.password_reset?.sms_reset_code_proceed }}</a>
                            </div>
                            <div class="p-mb-3">
                                <a href="/#/login-with-phone"><span class="pi pi-sign-in"></span>&nbsp;{{ $store.state.i18n.messageBundle?.auth?.useful_links?.login_with_phone }}</a>
                            </div> 
                            
                        </div>
                        <div style="padding-bottom: 50px"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import AuthService from '../service/AuthService';
import UtilService from '../service/UtilService';
export default {
    authService: null,
    utilService: null,
    setup: () => ({ v$: useVuelidate() }),
    data() {
        return {
            phone: null,
            phoneCountryCode: null,
            countryPhoneValue: null,
            countryPhoneValues: [
                { name: 'Australia', code: 'AU', phoneCountryCode: '+61' },
                //{name: 'China', code: 'CN', phoneCountryCode: '+86'},
                //{name: 'India', code: 'IN', phoneCountryCode: '+91'},
                { name: 'Indonesia ', code: 'ID', phoneCountryCode: '+62' },
                { name: 'Malaysia', code: 'MY', phoneCountryCode: '+60' },
                { name: 'Myanmar', code: 'MM', phoneCountryCode: '+95' },
                { name: 'Philippine', code: 'PH', phoneCountryCode: '+63' },
                { name: 'Singapore', code: 'SG', phoneCountryCode: '+65' },
                { name: 'Thailand', code: 'TH', phoneCountryCode: '+66' },
                //{name: 'Vietnam', code: 'VN', phoneCountryCode: '+84'},
            ],
            submitted: false,
            isProcessing: false,
            isError: false,
            isRequestSuccess: false,
            errorMsg: '',
        };
    },
    created() {
        this.$store.dispatch('createTitle', process.env.VUE_APP_QUOTE);
        this.authService = new AuthService();
        this.utilService = new UtilService();

        let user = this.$loadUserData(this);
        if (user) {
            this.$gotoProfile(this);
        }
    },
    validations() {
        return {
            phone: {
                required,
            },
            phoneCountrycode: {
                required,
            },
        };
    },
    methods: {
        async sendResetPasswordRequest() {
            try {
                this.isProcessing = true;
                this.isError = false;
                this.submitted = true;
                this.utilService.consoleLog('phone:', this.countryPhoneValue.phoneCountryCode+this.phone);
                let response = await this.authService.sendPasswordResetRequestByPhone(this.countryPhoneValue.phoneCountryCode.trim(),this.phone.trim());
                this.utilService.consoleLog('response:', response);
                this.isRequestSuccess = true;
            } catch (err) {
                let errObject = this.utilService.defineError(err);
                this.utilService.consoleLog('errObject:', errObject);
                if (errObject.errorDescription) {
                    this.errorMsg = errObject.errorDescription;
                } else {
                    this.errorMsg = 'Error occurred while processing request! Please try again later.';
                }
                this.isError = true;
                this.isRequestSuccess = false;
            } finally {
                this.isProcessing = false;
                this.submitted = false;
            }
        },
        updateCountryCode() {
            if (this.countryPhoneValue) {
                this.phoneCountryCode = this.countryPhoneValue.phoneCountryCode;
            } else {
                this.phoneCountryCode = null;
                this.phone = null;
            }
        },        
        gotoShop() {
            this.$gotoShop(this);
        },
        gotoRegistry() {
            this.$gotoAccountRegistry(this);
        },
        gotoEmailResetCodeRequest() {
            this.$gotoPasswordResetCodeEmailRequest(this);
        },
        gotoPhoneResetCodeRequest() {
            this.$gotoPasswordResetCodePhoneRequest(this);
        },
        gotoPasswordResetWithEmail() {
            this.$gotoResetPasswordWithEmail(this);
        },
        gotoPasswordResetWithPhone() {
            this.$gotoResetPasswordWithPhone(this);
        },
    },
};
</script>

<style lang="scss" scoped>
.password-input-text-corner {
    border-radius: 3px 0 0 3px !important;
    border-width: 1px 0 1px 1px !important;
}

.password-input-btn-corner {
    border-radius: 0 3px 3px 0;
    border-width: 1px 1px 1px 0;
    border-color: #65656a;
}

.login-body {
    overflow: hidden;
    position: relative;
    background: url('https://stc-content.ackaya.com/_exp_content/yuzaner/common/images/digital-bg1.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 150vh;
    padding: 0;
    margin: 0;
}

.login-holder {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
a {
    cursor: pointer;
}
a:hover {
    text-decoration: none;
}

.input-group-button {
    margin-top: 0em !important;
    display: block;
    min-width: auto !important;
}

.country-item {
    display: flex;
    align-items: center;
}
.country-item img.flag {
    width: 18px;
    margin-right: 0.5rem;
}

.multiselect-custom .country-placeholder {
    padding: 0.25rem;
}
::v-deep(.p-chips .p-chips-token) {
    background-color: var(--primary-color);
    color: var(--primary-color-text);
}
::v-deep(.p-autocomplete .p-autocomplete-multiple-container .p-autocomplete-token) {
    margin: 0.1rem 0.5rem 0.1rem 0;
}

.p-dropdown {
    width: 100%;
    font-weight: normal;
}

.phone-number-holder {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.country-code {
    width: 25%;
    margin-right: 2px;
}

.phone-number-input {
    width: 75%;
}

.login-body .login-panel {
    background-color: rgba(255, 255, 255, 0.9);
    opacity: 0.95;
}

@media screen and (max-width: 40em) {
    .login-body {
        height: 180vh;
    }

    .login-body .login-panel {
        background-color: rgba(255, 255, 255, 0.9);
        opacity: 0.95;
        height: 100%;
    }
}
</style>
